import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { nFormatter } from '../../../Helpers';
import { MaintenanceItemEmpty } from '../Dashboard';
import DashboardCardInfo from '../../../Components/common/DashboardCardInfo';

const PredictiveCard = ({
    amountColor,
    title,
    amount,
    isShowCurrency = false,
    isLoading = false,
    tooltipTitle
}) => {
    return (
        <Card sx={{ borderRadius: 2 }}>
            {
                isLoading ? (
                    <CardContent>
                        {Array.from({ length: 1 }).map((_, index) => (
                            <MaintenanceItemEmpty key={index} size="small" />
                        ))}
                    </CardContent>
                ) : (
                    <CardContent sx={{ position: "relative" }}>
                        <Typography
                            variant="subtitle2"
                            color="text.secondary"
                            gutterBottom
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="h6"
                            color={amountColor || 'text.secondary'}
                            sx={{ fontWeight: 'bold' }}
                            title={amount?.toLocaleString()}
                        >
                            {nFormatter(amount, 2)} {isShowCurrency ? "SAR" : ""}
                        </Typography>
                        <DashboardCardInfo title={tooltipTitle}/>
                    </CardContent>
                )
            }

        </Card>
    );
};

export default PredictiveCard;
